export default "__VITE_ASSET__KBjDCzKY__"